var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"i18n",rawName:"v-i18n",value:(_vm.dialog),expression:"dialog"}],staticClass:"ux-dialog",class:'ux-dialog-'+_vm.dialog.type})}
var staticRenderFns = []

export { render, staticRenderFns }